const autoNgTemplateLoaderTemplate1 = require('./networksDatatable.html');

angular.module('portainer.docker').component('networksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'NetworksDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    showHostColumn: '<',
    removeAction: '<',
    refreshCallback: '<',
  },
});
